/* import __COLOCATED_TEMPLATE__ from './decline-project.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { task } from 'ember-concurrency';
import { inject as service } from '@ember/service';
import { closeModal } from 'sh-www/utils/modal-controls';

class DeclineProjectModal extends Component {
  @service ('commands/application-commands') applicationCommandService;
  @service ('state-managers/application') applicationStateManager;
  @service('error-tracker') errorTracker;

  @tracked declineMessage = '';

  @task
  *declineProject() {
    const { project } = this.args.model;

    try {
      yield this.applicationCommandService.declineApplications([`${project.id}`], this.declineMessage);
      closeModal(this);
    } catch (error) {
      this.errorTracker.error(`declineProject failed to decline project id ${project.id}`, this, error);
      this.applicationStateManager.addToast('Failed to decline this project. Please try again.');
    }
  }

  @action
  handleDeclineProjectInput(value) {
    this.declineMessage = value;
  }

  @action
  handleDismiss() {
    closeModal(this);
  }
}

export default DeclineProjectModal;
